// Helper pour générer les URL d'API (les endpoints passés ici sont du type `/products`, `/admin/...` — la base doit finir par `/api`)
export const getApiUrl = (endpoint) => {
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const fromEnv = process.env.REACT_APP_BACKEND_URL
    ? String(process.env.REACT_APP_BACKEND_URL).replace(/\/$/, '')
    : '';
  const baseUrl =
    fromEnv ||
    (process.env.NODE_ENV === 'development'
      ? 'http://localhost:5000/api'
      : 'https://api.alturionlabs.com/api');
  return `${baseUrl.replace(/\/$/, '')}${path}`;
};

// Helper pour générer les URL des assets (images, etc.)
export const getAssetUrl = (path) => {
  // En développement, on utilise le serveur backend
  // En production, les images sont servies directement par le frontend
  if (process.env.NODE_ENV === 'production') {
    return path; // En production, utiliser le chemin tel quel
  } else {
    return `http://localhost:5000${path}`; // En dev, ajouter le domaine du backend
  }
}; 